export const isSwitchOrganizationAvailable = ({ availableOrganizations }) => {
  return (
    availableOrganizations.organizations.length > 1 ||
    availableOrganizations.organizations.some(org => !org.activated)
  );
};
